<template>
  <div class="flex items-start justify-start gap-2">
    <span
      class="flex-none flex items-center justify-center w-12 h-12 bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg">
      <Icon icon="tdesign:component-breadcrumb" width="25px" height="25px" />
    </span>
    <div class="flex flex-col">
      <div class="flex items-center gap-2">
        <p class="flex items-center gap-2 text-lg text-mainTitleLight dark:text-mainTitleDark font-bold">
          {{ title }}
        </p>
      </div>
      <div v-if="breadCrumb && breadCrumb.length > 0" class="hrmPageBreadCurmb">
        <span v-for="(item, index) in breadCrumb" :key="index" :class="item?.active ? 'hrmActiveBreadCrumb' : ''">
          {{ item.name }}<span v-if="index !== breadCrumb.length - 1"> / </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue";
export default {
  name: "PageHeader",
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    breadCrumb: {
      type: Array,
    },
  },
};
</script>